import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import DomainIcon from 'mdi-react/DomainIcon';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Button, ButtonToolbar, Col, InputGroup, Input, InputGroupAddon, InputGroupText, Row, FormText, FormGroup } from 'reactstrap';
import info from "../../../config/messages";

const validate = values => {
    const errors = {};
    if (!values.given_name) {
        errors.given_name = info.Validations.User.fname;
    }
    if (!values.family_name) {
        errors.family_name = info.Validations.User.lname;
    }
    if (!values.email) {
        errors.email = info.Validations.User.email;
    } else {
        var regexEmail = new RegExp("^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$");
        if (!regexEmail.test(values.email)) {
            errors.email = info.Validations.User.emailval;;
        }
    }
    return errors;
}

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class UpdateProfile extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  render() {
    const { handleSubmit, submitting} = this.props;
    const { showPassword } = this.state;

    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">First Name</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <DomainIcon />
            </div>
            <Field
              name="given_name"
              component={renderField}
              type="text"
              placeholder="First Name"
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Last Name</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="family_name"
              component={renderField}
              type="text"
              placeholder="Last Name"
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Phone Number</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <DomainIcon />
            </div>
            <Field
              name="phone_number"
              component={renderField}
              type="text"
              placeholder="Phone Number"
            />
          </div>
        </div>

         <div className="form__form-group">
          <span className="form__form-group-label">Email</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <DomainIcon />
            </div>
            <Field
              name="email"
              component={renderField}
              type="text"
              placeholder="Email"
            />
          </div>
         </div>

        <ButtonToolbar className="form__button-toolbar">
            <Button color="primary" disabled={submitting} type="submit">Update</Button>
        </ButtonToolbar>
      </form>
    );
  }
}


function mapStateToProps(state, ownProps, context) {
    const { data } = ownProps;
    return { initialValues: data }
}

let UpdateUserProfileData = reduxForm({
    validate: validate,
    form: 'updateUserForm',
    enableReinitialize: true
})(UpdateProfile);

export default connect(state => (mapStateToProps), {})(UpdateUserProfileData);